<template>
  <span v-if="item.subType === 'date'">
    {{ data[item.name] | filterTimeToFormatTime }}
  </span>
  <span v-else-if="item.subType === 'datetime'">
    <el-tooltip v-if="item.tip" class="item" effect="light" :content="data[item.name] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss')" placement="top">
      <span>{{ data[item.name] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss') }}</span>
    </el-tooltip>
    <span v-else>{{ data[item.name] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss') }}</span>
  </span>
  <span v-else-if="item.subType === 'obj'">
    {{ data[item.name] ? data[item.name][item.subName] : '' }}
  </span>
  <span v-else-if="item.subType === 'foreverDate'">
    {{ data[item.tip]}}
  </span>
  <span v-else-if="item.subType === 'tag'">
    {{ data[item.name] ? data[item.name].join(',') : '' }}
  </span>
  <span v-else-if="item.subType === 'select' && item.link" class="pointer" @click="selectLinkClick(data[item.name], item.option)" style="color: #2469c6">{{
    data[item.name] | filterData({ ...item, type: item.subType })
  }}</span>
  <span v-else-if="item.subType === 'select'">
    {{ data[item.tip] || data[item.name] | filterData({ ...item, type: item.subType }) }}
  </span>
  <span v-else-if="item.subType === 'selectAndSelect'">
    {{ data[item.name]| filterData({ ...item, type: "select" })}},{{ data[item.subName] | filterData({ option:item.subOption, type: "select" })}}
  </span>
  <span v-else-if="item.subType === 'money'">
    {{ data[item.name] | formatMoney(data[item.currencyId], '', item.isDcode, item.noSymbol, '', item.remainNum) }}
  </span>
  <span v-else-if="item.subType === 'category'">
    {{ data[item.tip]}}
  </span>
  <span v-else-if="item.subType === 'attachment'">
    {{ data[item.file_name]}}
  </span>
  <span v-else-if="item.subType === 'number'">
    {{ data[item.name] | formatNumber }}<span v-if="item.suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
  </span>
  <el-popover v-else-if="item.popover" placement="bottom" trigger="click" width="200" :content="item.popover">
    <span class="pointer" slot="reference">{{ data[item.name] }}</span>
  </el-popover>
  <span v-else-if="item.subType === 'todo'">TODO</span>
  <span v-else-if="item.subType === 'currency'">{{ (data[item.name] == 0 ? '8' : data[item.name]) | formatCurrency }}</span>
  <span v-else-if="item.subType === 'click' && item.isClick" class="pointer" @click="selectLinkClick(data[item.name], item)" :style="item.redWhenAttachment && data.has_spu_attachment ? 'color: red' : 'color: #2469c6'">{{ data[item.name] }}</span>
  <span v-else-if="item.subType === 'moneyClick'" class="pointer" @click="selectLinkClick(data[item.name], item)" style="color: #2469c6">
    {{ data[item.name] | formatMoney(data[item.currencyId], '', item.isDcode, item.noSymbol, '', item.remainNum) }}
  </span>
  <span
    :style="item.parentStyle"
    v-else-if="item.formatter && item.vHtml"
    v-html="item.formatter({
          row: data,
          column: item.id,
          cellValue: data[item.id],
        })"
      >
  </span>
  <div
    v-else-if="item.vHtml"
    v-html="data[item.name]"
  >
  </div>
  <div v-else-if="item.subType==='html'">
    <span v-html="data[item.name]"></span>
  </div>
  <div v-else-if="item.subType==='link'">
    <span>{{item.linkData.prompt}}</span><router-link :target="item.linkData.target" :to="item.linkData.to" :class="'clickable'">{{item.linkData.text}}</router-link><span>{{item.linkData.prompt_end}}</span>
  </div>
  <div v-else-if="item.subType==='tip'">
    <el-tooltip v-if="item.tooltip" :content="data[item.tip]" placement="top" effect="light">
      <span>{{data[item.tip]}}</span>
    </el-tooltip>
    <span v-else>{{data[item.tip]}}</span>
  </div>
  <div v-else-if="item.subType==='isSlot'">
    <slot :name="item.slotName" ></slot>
  </div>
  <span v-else :title="data[item.tip] || data[item.name]">
    {{ data[item.name] | filterData({ tip: data[item.tip] || data[item.name], type: item.subType}) }}
    <span v-if="item.suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
  </span>
</template>
<script>
export default {
  name: 'baseInfo-readonly',
  props: ['data', 'item'],
  methods: {
    // 下拉可点击链接 (选中的值, 整个options)
    selectLinkClick(val, option) {
      this.$emit('selectLinkClick', val, option);
    }
  },
  created() {
  }
};
</script>
